export default __webpack_public_path__ + "static/shutterstock_9-216e432e758b4a090c505e756af1dded.jpg";